module.exports = __webpack_public_path__ + "img/you-da-one.80b7c6f4.jpg";